{
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "nav": {
    "forSubscriber": "订户",
    "readEpaper": "阅读电子报",
    "readEpaperShort": "阅读电子报"
  },
  "hero": {
    "headline": "指尖翻阅的熟悉感，一键智读的新体验。",
    "subheadline": "",
    "cta": "获取电子报"
  },
  "feature": {
    "heading": "电子报的四大亮点",
    "read": {
      "chip": "随时畅读",
      "title": "随时随地，指尖尽览每日新闻",
      "deviceAlt": "电子报阅读器中的《联合早报》头版"
    },
    "zoom": {
      "chip": "自由缩放",
      "title": "点看更大、更清晰的新闻版面",
      "deviceAlt": "电子报阅读器中放大的文章"
    },
    "layout": {
      "chip": "报纸排版",
      "title": "原版呈现，轻松一览新闻全貌",
      "deviceAlt": "电子报阅读器数码排版中的文章"
    },
    "share": {
      "chip": "快速分享",
      "title": "快捷裁切文章，通过社交媒体与亲友分享",
      "deviceAlt": "电子报阅读器中打开分享与下载工具的头版"
    }
  },
  "startReading": "立即阅读电子报",
  "subscription": {
    "label": "",
    "heading": "超值订阅\n畅读每日新闻，14天电子报库供随时查阅",
    "pricePrefix": "每月",
    "priceSuffix": "起",
    "cta": "立即订阅",
    "slideAlt": "{{publication}}电子报阅读器画面",
    "pubs": {
      "st": {
        "heading": "Your chosen title, every morning with 14 days of past issues always within reach",
        "pricePrefix": "from",
        "priceSuffix": "/ month",
        "cta": "Subscribe"
      },
      "bt": {
        "heading": "Your chosen title, every morning with 14 days of past issues always within reach",
        "pricePrefix": "from",
        "priceSuffix": "/ month",
        "cta": "Subscribe"
      },
      "zb": {
        "label": "",
        "heading": "超值订阅\n畅读每日新闻，14天电子报库供随时查阅",
        "pricePrefix": "每月",
        "priceSuffix": "起",
        "cta": "立即订阅",
        "name": "联合早报"
      },
      "sm": {
        "label": "",
        "heading": "超值订阅\n畅读每日新闻，14天电子报库供随时查阅",
        "pricePrefix": "每月",
        "priceSuffix": "起",
        "cta": "立即订阅",
        "name": "新明日报"
      },
      "bh": {
        "heading": "Tajuk pilihan anda, setiap pagi dengan 14 hari isu lepas sentiasa dalam jangkauan",
        "pricePrefix": "Dari",
        "priceSuffix": "/ bulan",
        "cta": "Langgan"
      },
      "tm": {
        "heading": "நீங்கள் தேர்ந்தெடுத்த இதழ், ஒவ்வொரு காலையிலும் கடந்த 14 நாட்களின் இதழ்களுடன் எப்போதும் உங்கள் கைக்கு எட்டும் தூரத்தில்.",
        "pricePrefix": "மாதத்திற்கு",
        "priceSuffix": "முதல்",
        "cta": "சந்தா சேருங்கள்"
      }
    }
  },
  "singleCopy": {
    "label": "",
    "heading": "单份按日购买\n无需合约，随心畅读；支持三部智能设备同时阅读，有效期限为14天。",
    "pricePrefix": "每日",
    "priceSuffix": "起",
    "cta": "购买当日电子报",
    "imageAlt": "手机显示电子报应用，一页报纸从屏幕中浮现"
  },
  "newsTablet": {
    "heading": "平板电子报配套",
    "description": "含崭新平板电脑，无需密码登录，每日尽览<0>《联合早报》</0>与<0>《新明日报》</0>双份电子报。",
    "pricePrefix": "每月",
    "priceSuffix": "起",
    "contract": "(24个月合约)",
    "terms": "附带条款",
    "cta": "立即订阅",
    "imageAlt": "SPHtab 平板电脑显示《联合早报》电子报"
  },
  "plans": {
    "included": "权益包括：",
    "subscription": {
      "title": "订阅",
      "benefits": {
        "zb": [
          "长达两周的<0>《联合早报》</0>及<0>《新明日报》</0>电子报库",
          "解锁与赠阅订户专享文章给非订户",
          "联合早报俱乐部VIP会员福利"
        ],
        "sm": [
          "长达两周的<0>《新明日报》</0>电子报库",
          "每日发行的印刷版<0>《新明日报》</0>（隔天派送）"
        ]
      },
      "pubs": {
        "zb": {
          "cta": "订阅数码配套"
        },
        "sm": {
          "cta": "订阅电子报"
        }
      }
    },
    "single": {
      "title": "单期",
      "benefits": {
        "default": [
          "单期购买，无合约",
          "一份电子报有14天的阅读权限",
          "可同时在3台智能设备阅读"
        ]
      },
      "pricePrefix": "每份",
      "priceSuffix": "",
      "cta": "购买一期"
    },
    "tablet": {
      "benefits": {
        "default": [
          "获一部全新平板电脑",
          "长达两周的<0>《联合早报》</0>及<0>《新明日报》</0>电子报库",
          "解锁与赠阅订户专享文章给非订户",
          "联合早报俱乐部VIP会员福利"
        ]
      },
      "title": "平板电子报",
      "cta": "订阅平板电子报配套",
      "contract": ""
    },
    "heading": "开始阅读电子报"
  },
  "selector": {
    "aria": "选择刊物"
  },
  "publications": {
    "st": "海峡时报",
    "zb": "联合早报",
    "sm": "新明日报",
    "tm": "淡米尔之声",
    "bt": "商业时报",
    "bh": "每日新闻"
  },
  "links": {
    "buyToday": "https://subscribe.sph.com.sg/pages/zh/epaper/buy?utm_campaign=singlecopyepaper&utm_medium=sph-publication&utm_source=epaperlp&utm_content=purchaselink-epaperlp-singlecopy",
    "publications": {
      "st": "https://subscribe.sph.com.sg/zh/publications-st?utm_campaign=st_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-st",
      "zb": "https://subscribe.sph.com.sg/zh/publications-zb?utm_campaign=zb_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-zb",
      "sm": "https://subscribe.sph.com.sg/zh/publications-sm?utm_campaign=sm_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-sm",
      "tm": "https://subscribe.sph.com.sg/zh/publications-tm?utm_campaign=tm_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-tm",
      "bt": "https://subscribe.sph.com.sg/zh/publications-bt?utm_campaign=bt_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-bt",
      "bh": "https://subscribe.sph.com.sg/zh/publications-bh?utm_campaign=bh_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-bh"
    },
    "newsTablet": "https://subscribe.sph.com.sg/zh/promotions/zbnt-evergreen-a11/?utm_campaign=zbnt_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-zbnt"
  },
  "footer": {
    "about": "关于我们",
    "promotions": "促销",
    "subscriptionTerms": "订阅条款与细则",
    "termsConditions": "条款与细则",
    "cookieNotice": "Cookie 使用声明",
    "personalDataProtection": "个人资料保护声明",
    "officialDomains": "官方域名",
    "contactUs": "联系我们",
    "onlineForm": "意见反馈",
    "generalEnquiries": "一般类咨询:",
    "corporateEnquiries": "企业咨询:",
    "copyright": "Copyright © {{year}} SPH Media Limited. Co. Regn. No. 198402868E. All Rights Reserved.",
    "address": "1000 Toa Payoh North Annexe Level 6, News Centre Singapore 318994",
    "feedback": "意见反馈"
  },
  "footerLinks": {
    "promotions": "https://subscribe.sph.com.sg/zh/promotions-listing/",
    "subscriptionTerms": "https://subscribe.sph.com.sg/tnc/standard/",
    "termsConditions": "https://www.sph.com.sg/legal/website_tnc/",
    "cookieNotice": "https://www.sph.com.sg/tnc/cookie/",
    "personalDataProtection": "https://www.sph.com.sg/tnc/pdpa/",
    "officialDomains": "https://www.sph.com.sg/official-domains",
    "onlineForm": "https://subscribe.sph.com.sg/zh/contact-us/"
  },
  "heroTitle": "立即订阅，畅读当日完整电子报及前14天往期存档。",
  "heroSubtitle": "传统排版与现代视图，一键自由切换——你的报纸，以你的方式阅读。",
  "or": "或者",
  "singleCopyTitle": "当日电子报——按次在线购买，无续费压力，享受阅读的自由。",
  "singleCopySubtitle": "",
  "buyToday": "购买当日电子报"
}
